// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.share-link-icons {
  font-family: sans-serif;
  font-weight: 900;
  background-color: #4b8ffe;
  background-color: var(--cta-color-hover);
  color: white !important;
  font-size: 1.0em !important;
  padding-top: 0.4em !important;
  padding-bottom: 0.4em !important;
  padding-right: 0.8em !important;
}
.share-link-loading {
  background-color: var(--cta-color);
  color: white;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  padding-top: 0.4em;
}
.p-error {
  color: red;
  font-size: 0.8em;
}
`, "",{"version":3,"sources":["webpack://./src/Property.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["\n.share-link-icons {\n  font-family: sans-serif;\n  font-weight: 900;\n  background-color: #4b8ffe;\n  background-color: var(--cta-color-hover);\n  color: white !important;\n  font-size: 1.0em !important;\n  padding-top: 0.4em !important;\n  padding-bottom: 0.4em !important;\n  padding-right: 0.8em !important;\n}\n.share-link-loading {\n  background-color: var(--cta-color);\n  color: white;\n  font-family: Roboto, sans-serif;\n  font-weight: bold;\n  padding-top: 0.4em;\n}\n.p-error {\n  color: red;\n  font-size: 0.8em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
